<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Discussion Summary">
        <div class="row">
        <div class="col-md-6 form-group">
        Topic
          <input class="form-control" type = "text" v-model="topic" readonly />
        </div>
        <div class="col-md-6 form-group">
          User Name
           <input class="form-control" type = "text" v-model="name" readonly />
        </div>
        <div class="col-md-6 form-group">
          Image
          <br>
         <img :src="image" style="width: 200px;"/>
        </div>
        <div class="col-md-12 form-group">
          Query
          <b-textarea class="form-control" type = "text" v-model="query" readonly />
        </div>
        <div class="col-md-12 form-group">
          Description
          <b-textarea class="form-control" type = "text" v-model="description" readonly />
        </div>
      <div class="col-md-12 form-group">
           <div class="mb-2"> <b>Discussion Threads</b></div>

            <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
               <b-th class="text-center">Name</b-th>
              <b-th class="text-center">Query</b-th>
              <b-th class="text-center" v-if="$store.getters.userDetails.includes('CAN_APPROVAL_DISCUSSION')">Status</b-th>
              <b-th class="text-center">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(comment, index) in comments" :key="index">
              <b-td class="text-center">
                 {{ index + 1 }}
              </b-td>
              <b-td class="text-center">
               {{comment.threadable.name}}
              </b-td>
              <b-td class="text-center">
              {{comment.reply}}
              </b-td>
               <b-td class="text-center" v-if="$store.getters.userDetails.includes('CAN_APPROVAL_DISCUSSION')">
                <b-button
                  :class="comment.approval == 1 ? 'btn-success' : comment.approval == 0 ? 'btn-secondary' : 'btn-danger'"
                  size="sm"
                  @click="toggleStatus(comment.id, index, comment.approval)"
                >
                  {{ comment.approval == 1 ? "Approved" : comment.approval == 2 ? "Not Approved" : "waiting" }}
                </b-button>
              </b-td>
              <b-td class="text-center" v-if="$store.getters.userDetails.includes('CAN_DELETE_DISCUSSION')">
                  <b-button size="sm" variant="alt-primary"  @click="deleteComment(comment.id)">
                    <i class="fa fa-fw fa-times"></i>
                  </b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

      </div>


      </div>
    </base-block>
     <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      id: "",
      topic:"",
      name:"",
      query: "",
      image:"",
      description:"",
      comments: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/threads/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.id = response.data.discussions.id;
            this.query = response.data.discussions.query;
            this.topic = response.data.discussions.topic.name;
            this.name = response.data.discussions.user.name;
            this.image = response.data.discussions.image;
             this.description = response.data.discussions.description;
            this.comments = response.data.comments;
          } else {
            this.$swal("Success", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async deleteComment(id) { 
      await axios
        .get(`${this.$store.getters.baseUrl}/threads/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then(response => {
          console.log(response);
          if(response.data.status == "success") {
            this.loadData();
            this.$swal("Success", "Comment deleted successfully", "success");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch(error => {
          this.$swal("Error", error.response.data.message, "error");
        })
    },
     async toggleStatus(id, index, approval) {
      await axios
        .get(`${this.$store.getters.baseUrl}/threads/status/${id}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.comments[index].approval = approval == 1 ? 2 : approval == 2 ? 0 : 1;
            this.$swal("Success", "Discussion thread status has been changed successfully", "success");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

